import { z } from "zod";

export const MAX_BRAND_FILTERS = 20;
const MAX_BRAND_ID = 2_147_483_647;

export function parseBrandIds(value: unknown): number[] | undefined {
  if (value == null || value === "") {
    return undefined;
  }

  const list = Array.isArray(value) ? value : [value];
  const ids: number[] = [];

  for (const item of list) {
    if (ids.length >= MAX_BRAND_FILTERS) {
      break;
    }

    const parsed = parseBrandId(item);
    if (parsed === null || ids.includes(parsed)) {
      continue;
    }

    ids.push(parsed);
  }

  return ids.length > 0 ? ids : undefined;
}

export function toggleBrandId(values: number[] | undefined, id: number): number[] | undefined {
  if (!Number.isSafeInteger(id) || id < 1 || id > MAX_BRAND_ID) {
    return values;
  }

  const current = values ?? [];
  if (current.includes(id)) {
    const next = current.filter((item) => item !== id);
    return next.length > 0 ? next : undefined;
  }

  if (current.length >= MAX_BRAND_FILTERS) {
    return current;
  }

  return [...current, id];
}

export const brandIdsSchema = z.preprocess((value) => {
  if (value === undefined || value === null) {
    return undefined;
  }

  return parseBrandIds(value);
}, z.array(z.number().int().min(1).max(MAX_BRAND_ID)).max(MAX_BRAND_FILTERS).optional());

function parseBrandId(item: unknown): number | null {
  let parsed: number | null = null;

  if (typeof item === "number" && Number.isFinite(item)) {
    parsed = item;
  } else if (typeof item === "string" && /^[0-9]{1,10}$/.test(item.trim())) {
    parsed = Number(item.trim());
  }

  if (parsed === null || !Number.isSafeInteger(parsed) || parsed < 1 || parsed > MAX_BRAND_ID) {
    return null;
  }

  return parsed;
}
